import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
  overflow-y: auto;
`;

export const ComponentLabel = styled.div`
  background: ${(props) => props.theme.colors.info || '#52c41a'};
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  margin-bottom: 8px;
  margin-top: 8px;
  width: fit-content;
  display: block;
`;
